var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.display
    ? _c("div", { staticClass: "line-item__delete cart__confimation" }, [
        _c(
          "p",
          { staticClass: "cart__confimation__heading" },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$modeoL10n.are_you_sure_you_want_to_remove) +
                "\n    "
            ),
            _vm.quantity > 1
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.quantity) +
                      " " +
                      _vm._s(_vm.$modeoL10n.remove_products_confirmation) +
                      "\n    "
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.quantity == 1
              ? [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$modeoL10n.remove_product_confirmation) +
                      "\n    "
                  )
                ]
              : _vm._e(),
            _vm._v("?\n  ")
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "cart__confimation__actions cart__confimation__actions--small"
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "btn btn--secondary btn--secondary-small btn--inline",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.cancel()
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(_vm.$modeoL10n.cancel) + "\n    ")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn--small btn--inline",
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.confirm()
                  }
                }
              },
              [_vm._v("\n      " + _vm._s(_vm.$modeoL10n.remove) + "\n    ")]
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01325ed4", { render: render, staticRenderFns: staticRenderFns })
  }
}